(() => {
  if (window.marzoCollectionStoriesReady) return;
  window.marzoCollectionStoriesReady = true;
  const enhance = root => root.querySelectorAll('.lb-story__rail-controls, .lb-story__fold-bottom').forEach(el => {
    el.hidden = false;
    el.classList.add('is-enhanced');
  });
  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-lb-collapse], [data-lb-scroll]');
    if (!button || !button.closest('.lb-story')) return;
    if (button.hasAttribute('data-lb-collapse')) {
      const details = button.closest('details');
      if (!details) return;
      details.open = false;
      const summary = details.querySelector('summary');
      summary.focus({preventScroll:true});
      summary.scrollIntoView({block:'center',behavior:'auto'});
    } else {
      const rail = button.closest('.lb-story__related').querySelector('.lb-story__related-track');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rail.scrollBy({left: Number(button.dataset.lbScroll) * rail.clientWidth * .82, behavior:reduce ? 'auto' : 'smooth'});
    }
  });
})();
